module.exports = __webpack_public_path__ + "static/Q7Answer3_Beach_Sean-4b718e7d61b13656c1a1f40a644925ae.jpg";